/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { QuestionGroup, ScopeQuestionOptionalValue } from '@g17eco/types/survey';
import { SurveyActionData } from '@g17eco/types/surveyAction';

export type SurveyGroupsData<T extends ScopeQuestionOptionalValue = ScopeQuestionOptionalValue> = Pick<SurveyActionData,
  'scope' |
  'customMetricGroups' |
  'contributions' |
  'initiativeId' |
  'initiatives' |
  'utrSortingConfigMap'
  > & {
  questionGroups: QuestionGroup<T>[];
  fragmentUniversalTrackerValues?: SurveyActionData['fragmentUniversalTrackerValues']
};


export const isSurveyActionData = (d: Partial<SurveyActionData>): d is SurveyActionData => Boolean(d._id)
